<app-input-header *ngIf="outsideLabel && labelKey" [labelKey]="labelKey" [required]="required"></app-input-header>
<mat-form-field
  appearance="outline"
  class="full-width background-white timepicker"
  [ngClass]="{ 'input-error': control.touched && control.errors }"
>
  <mat-label *ngIf="!outsideLabel && labelKey">{{ labelKey | locLabel }}</mat-label>
  <input
    matInput
    [disabled]="disabled"
    [placeholder]="placeholderKey | locLabel"
    [ngxMatTimepicker]="picker"
    [ngModel]="value"
    (blur)="onTouch()"
    (ngModelChange)="value = $event"
    [format]="24"
  />
  <ngx-mat-timepicker-toggle matSuffix [disabled]="disabled" [for]="picker"></ngx-mat-timepicker-toggle>
  <ngx-mat-timepicker #picker color="primary" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn"></ngx-mat-timepicker>
</mat-form-field>
<app-input-footer *ngIf="footer" [control]="control"></app-input-footer>

<ng-template #cancelBtn>
  <button mat-stroked-button class="mat-primary margin-right-10">{{ 'button.cancel' | loc }}</button>
</ng-template>
<ng-template #confirmBtn>
  <button mat-raised-button class="mat-primary mat-elevation-z0">{{ 'button.save' | loc }}</button>
</ng-template>
